module.exports = __webpack_public_path__ + "static/media/8.848d0395.png";